import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthProvider';
import { useAuth } from './lib/auth';
import Header from './components/layout/Header';
import AuthForm from './components/auth/AuthForm';
import CardCollection from './components/CardCollection';
import Booster from './components/pages/Booster';
import Combat from './components/pages/Combat';
import CombatArena from './components/pages/CombatArena';
import Admin from './components/pages/Admin';

function PrivateRoute({ children, adminOnly = false }: { children: React.ReactNode, adminOnly?: boolean }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (!user) {
    return <Navigate to="/auth" />;
  }

  if (adminOnly && user.email !== 'admin@baby-sittign.xyz') {
    return <Navigate to="/collection" />;
  }

  return (
    <>
      <Header />
      {children}
    </>
  );
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (user) {
    return <Navigate to="/collection" />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/auth" element={
          <PublicRoute>
            <AuthForm />
          </PublicRoute>
        } />
        <Route path="/" element={<Navigate to="/collection" replace />} />
        <Route path="/collection" element={
          <PrivateRoute>
            <CardCollection />
          </PrivateRoute>
        } />
        <Route path="/booster" element={
          <PrivateRoute>
            <Booster />
          </PrivateRoute>
        } />
        <Route path="/combat" element={
          <PrivateRoute>
            <Combat />
          </PrivateRoute>
        } />
        <Route path="/combat/arena/:sessionId" element={
          <PrivateRoute>
            <CombatArena />
          </PrivateRoute>
        } />
        <Route path="/admin" element={
          <PrivateRoute adminOnly>
            <Admin />
          </PrivateRoute>
        } />
      </Routes>
    </AuthProvider>
  );
}